import { RouteConfig } from 'vue-router'

export const inAppNotificationRoutes: RouteConfig[] = [
  {
    path: '/in-app-notifications',
    name: 'in-app-notifications',
    component: () =>
      import(
        /* webpackChunkName: "NotificationsChunk" */ '@/modules/in-app-notification/views/TheNotification.vue'
      ),
    meta: {
      parentRouteName: null,
      title: 'navigations.inAppNotifications'
    }
  },
  {
    path: '/in-app-notifications/:id',
    name: 'in-app-notification-detail',
    component: () =>
      import(
        /* webpackChunkName: "NotificationsChunk" */ '@/modules/in-app-notification/views/TheNotificationDetail.vue'
      ),
    meta: {
      parentRouteName: 'in-app-notifications',
      title: 'navigations.inAppNotificationDetail'
    }
  }
]
